import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import SideBarSkeleton from "../../Component/SideBarSkeleton";
import { thumbnail } from "../../constant/imagePath";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import classes from "./ScheduledVideos.module.css";
import { Button } from "../../Component/Button/Button";
import RescheduleModal from "../../modals/RescheduleModal";
import EditVideo from "../../modals/EditVideo";
import AreYouSureModal from "../../modals/AreYouSureModal";
import { Delete, Get, Patch } from "../../Axios/AxiosFunctions";
import {
  apiHeader,
  BaseURL,
  capitalizeFirstLetter,
  endpointsUrl,
  formRegEx,
  formRegExReplacer,
  imageUrl,
  recordsLimit,
} from "../../config/apiUrl";
import { useSelector } from "react-redux";
import { Loader } from "../../Component/Loader";
import ReactPlayer from "react-player";
import { BsFillPlayFill } from "react-icons/bs";
import ViewVideoModal from "../../modals/ViewVideoModal";
import moment from "moment";
import EditVideoModal from "../../modals/EditVideoModal";
import axios from "axios";
import { toast } from "react-toastify";
import { json, useNavigate } from "react-router-dom";
import PaginationComponent from "../../Component/PaginationComponent";
import NoData from "../../Component/NoData/NoData";
import { useRef } from "react";
import ShowMoreShowLessText from "../../Component/ShowMoreShowLess/ShowMoreShowLessText";
const ScheduledVideos = () => {
  const [show, setShow] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { access_token, user } = useSelector((state) => state?.authReducer);
  const [selectedItem, setSelectedItem] = useState(null);
  const [videFile, setVideFile] = useState(null);
  const [isLoadingEdit, setIsLoadingEdit] = useState(false);
  const [videoProgress, setVideoProgress] = useState(0);
  const [thumbnailPicture, setThumbnailPicture] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  console.log(selectedItem, "selectedItem selectedItem selectedItem");

  // Pagination
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();

  const getData = async (pg = pageNo) => {
    setIsLoading(true);
    const response = await Get(
      BaseURL(
        `video/${endpointsUrl(
          user?.role
        )}/all?page=${pg}&limit=${recordsLimit}&status=scheduled`
      ),
      access_token
    );
    setIsLoading(false);

    if (response) {
      setResponseData(response?.data?.data);
      setTotalRecords(response?.data?.totalRecords);
    }
  };
  useEffect(() => {
    getData();
  }, [pageNo]);
  const handleEdit = async (params) => {
    let data = { ...params };

    for (var key in data) {
      if (key == "isVideo") {
        continue;
      }
      if (data[key] == "" || data[key] == null) {
        return toast.warn(
          `Please fill ${capitalizeFirstLetter(
            key?.replace(formRegEx, formRegExReplacer)
          )}`
        );
      }
    }
    console.log(
      data?.thumbnail,
      "data?.thumbnail data?.thumbnail data?.thumbnail"
    );
    const formData = new FormData();
    formData.append("fromGallery", !data?.isVideo);
    for (var key in data) {
      formData.append(key, data[key]);
    }
    setIsLoadingEdit(true);

    const response = await Patch(
      BaseURL(`video/${selectedItem?._id}`),
      formData,
      apiHeader(access_token)
    );

    if (response != undefined) {
      !response?.data?.data?.url && getData();
      setResponseData((prev) => {
        const updatedPrev = [...prev];
        updatedPrev.splice(selectedItem?.index, 1, response?.data?.data?.doc);
        return updatedPrev;
      });

      !!response?.data?.data?.url &&
        (await axios
          .put(response?.data?.data?.url, videFile, {
            headers: {
              "Content-Type": videFile?.type,
            },
            onUploadProgress: (data) => {
              setVideoProgress(Math.round((100 * data.loaded) / data.total));
            },
          })
          .then(() => {
            getData();
            setVideoProgress(0);
          })
          .catch(async () => {
            const url = BaseURL(`video/${response?.data?.data?._id}`);
            const response = await Delete(url, null, apiHeader(access_token));
            if (response) {
              console.log("Video deleted");
            }
          }));
      setVideoProgress(0);

      setIsLoadingEdit(false);

      toast.success("Video uploaded successfully");
      // navigate(-1);

      setShow(false);
      setThumbnailPicture(null);
    } else {
      setIsLoadingEdit(false);
    }
  };

  const deleteVideo = async () => {
    const url = BaseURL(`video/${selectedItem?._id}`);
    setDeleteLoading(true);
    const response = await Delete(url, null, apiHeader(access_token));
    if (response) {
      const newData = [...responseData];
      newData?.splice(
        newData?.findIndex((item) => item?._id == selectedItem?._id),
        1
      );
      setResponseData(newData);
      toast.success("Video Succesfully Deleted");
    }
    setDeleteLoading(false);
    setShow("");
  };

  return (
    <>
      <SideBarSkeleton>
        <Container className={`custom_conti_b ${classes.pageContent}`}>
          <Row>
            <Col md={12}>
              <h3>Scheduled Videos</h3>
            </Col>
            {isLoading ? (
              <Loader className={classes.loader} />
            ) : responseData?.length > 0 ? (
              responseData?.map((item, index) => {
                return (
                  <Col xl={4} lg={6} md={6} sm={12} key={index}>
                    <div className="mb-5">
                      <div className={classes.image_div}>
                        <img
                          src={imageUrl(
                            item?.fromGallery
                              ? item?.gallery?.thumbnail
                              : item?.thumbnail
                          )}
                          alt="Thumbnail"
                        />
                        <div
                          className={classes.playIconDiv}
                          onClick={() => {
                            setSelectedItem(item);
                            setShow("Video");
                          }}
                        >
                          <BsFillPlayFill size={25} />
                        </div>
                      </div>
                      <div>
                        <div className={classes.name_div}>
                          <div className={classes.heading_channel}>
                            <h4>{item?.channel?.instagramId}</h4>
                          </div>
                          <div className={classes.icon_main_div}>
                            <div
                              onClick={() => {
                                setSelectedItem({ ...item, index });

                                setShow("Edit");
                              }}
                            >
                              <EditIcon />
                            </div>
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedItem(item);

                                setShow("Delete");
                              }}
                            >
                              <DeleteIcon />
                            </div>
                            <div
                              onClick={() => {
                                setSelectedItem({ ...item, index });

                                setShow("ediTVideo");
                              }}
                            >
                              <CloudDownloadIcon />
                            </div>
                          </div>
                        </div>
                        <div>
                          <p>
                            <ShowMoreShowLessText text={item?.description} />
                          </p>
                          <div className={classes.date_div}>
                            <b>
                              Date :{" "}
                              {moment(item?.scheduledDate).format("MM/DD/YYYY")}
                            </b>
                            <b>
                              Time : /{" "}
                              {moment(item?.scheduledDate).format("h:mm A")}
                            </b>
                          </div>
                          <div className={classes.schedule_btns}>
                            <Button
                              onClick={() => {
                                setSelectedItem({ ...item, index });

                                setShow("Rescheduled");
                              }}
                              label={"Rescheduled"}
                            />
                            <Button
                              green
                              onClick={() => {
                                navigate(`/VideoDetails/${item?._id}`);
                              }}
                              label={"View"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })
            ) : (
              <NoData text={"No Video Found"} />
            )}
          </Row>
          <div className={classes.paginationDiv}>
            <PaginationComponent
              currentPage={pageNo}
              setCurrentPage={setPageNo}
              totalPages={Math.ceil(totalRecords / recordsLimit)}
            />
          </div>
        </Container>
      </SideBarSkeleton>
      {show == "Delete" && (
        <AreYouSureModal
          subTitle={"Are You Sure You Want To Delete This Video ?"}
          show={show == "Delete"}
          setShow={setShow}
          isApiCall={deleteLoading}
          onClick={deleteVideo}
        />
      )}
      {show == "Rescheduled" && (
        <RescheduleModal
          isLoadingEdit={isLoadingEdit}
          handleEdit={handleEdit}
          selectedItem={selectedItem}
          show={show == "Rescheduled"}
          setShow={setShow}
        />
      )}
      {show == "ediTVideo" && (
        <EditVideoModal
          handleEdit={handleEdit}
          selectedItem={selectedItem}
          width="1289px"
          show={show == "ediTVideo"}
          setShow={setShow}
          setVideFile={setVideFile}
          thumbnailPicture={thumbnailPicture}
          videoProgress={videoProgress}
          videFile={videFile}
          isLoadingEdit={isLoadingEdit}
          setThumbnailPicture={setThumbnailPicture}
        />
      )}
      {show == "Edit" && (
        <EditVideo
          isLoadingEdit={isLoadingEdit}
          handleEdit={handleEdit}
          selectedItem={selectedItem}
          width="1289px"
          show={show == "Edit"}
          setShow={setShow}
        />
      )}
      {show == "Video" && (
        <ViewVideoModal
          selectedItem={selectedItem}
          show={show == "Video"}
          setShow={setShow}
          data={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      )}
    </>
  );
};

export default ScheduledVideos;
